import { fromJS } from 'immutable'

import { EmptyAlert } from 'static/constants'
import { mergeAlert } from 'utils/alerts'

const emptyAlert = fromJS(EmptyAlert)

export const getAlertsState = state => state.alerts
export const getAlertsEdit = state => getAlertsState(state).get('edit')
export const getAlertsUi = state => getAlertsState(state).get('ui')

export const getAlertsData = state => getAlertsState(state).get('data')
export const getAlerts = state => getAlertsData(state).get('alerts')
export const getAlertsForSavedSearchId = (state, savedSearchId) => getAlerts(state).filter(alert => (
  alert.getIn(['condition', 'savedSearchId']) === savedSearchId
))
export const getExistingAlertIds = state => getAlerts(state).keySeq().toSet()
export const getAlertHistory = state => getAlertsData(state).get('history')
export const getAlertPreviewActions = state => getAlertsData(state).get('previewActions').toJS()
export const getAlertPreviewCondition = state => getAlertsData(state).get('previewCondition').toJS()
export const getAlertPreviewResults = state => getAlertsData(state).get('previewResults').toJS()
export const getRemoveAlert = state => getAlertsData(state).get('removeAlert')

export const getShowRemoveAlertDialog = state => getAlertsUi(state).get('removeActive')
export const getShowAlertDialog = state => getAlertsEdit(state).getIn(['ui', 'open'])
export const getShowAlertPreviewDialog = state => getAlertsUi(state).get('previewActive')
export const getAlertPreviewLoading = state => getAlertsUi(state).get('previewLoading')
export const getSaveAlertRunning = state => getAlertsEdit(state).getIn(['ui', 'running'])
export const getAlertsLoading = state => getAlertsUi(state).get('loading')
export const getAlertsStatusLoading = state => getAlertsUi(state).get('statusLoading')
export const getAlertHistoryLoading = state => getAlertsUi(state).get('historyLoading')
export const getAlertHistoryError = state => getAlertsUi(state).get('historyError')

export const getSelectedAlertId = state => getAlertsEdit(state).getIn(['data', 'selectedAlertId'])

export const getSelectedAlert = state => {
  const selectedAlert = getAlertsEdit(state).getIn(['data', 'selectedAlert'])

  if (selectedAlert) {
    return selectedAlert
  }

  const selectedAlertId = getSelectedAlertId(state)
  const alert = selectedAlertId == null ? null : getAlerts(state).get(String(selectedAlertId))

  return alert ? mergeAlert(alert) : emptyAlert
}
